<div
    style="
        height: calc(100vh - 100px);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    "
>
    <h4 style="font-size: 1.25rem; font-weight: 600">
        {{ "Account not related to a student" | translate }}.
    </h4>
    <p>{{ "Please contact your administrator" | translate }}.</p>
    <p>
        {{ "You will be redirected in" | translate }} {{ time }}
        {{ "seconds" | translate }}
    </p>
</div>
